import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useDonationTotal, useWidgetStore } from "../../../../store/store";
import { Donation } from "../../../../store/state";
import { draftAvtaleGiro } from "../../../../store/flows";
import { API_URL } from "../../../../config/api";
import { AVTALEGIRO_COMPANY_ACCOUNT_NO, AVTALEGIRO_COMPANY_NAME, AVTALEGIRO_FORM_URL, AVTALEGIRO_MIN_AMOUNT_LIMIT } from "../../../../config/avtalegiro";
import { SubmitButton } from "../../../shared/Buttons/NavigationButtons";
import { usePlausible } from "next-plausible";
export const RecurringBankDonationForm: React.FC<{
  donation: Donation;
  buttonText: string;
}> = t0 => {
  const $ = _c(23);
  const {
    donation,
    buttonText
  } = t0;
  const store = useWidgetStore();
  const plausible = usePlausible();
  const totalSumIncludingTip = useDonationTotal();
  let t1;
  if ($[0] !== plausible || $[1] !== store) {
    t1 = e => {
      plausible("DraftAvtalegiro");
      e.preventDefault();
      draftAvtaleGiro(store);
    };
    $[0] = plausible;
    $[1] = store;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onSubmit = t1;
  let t2;
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      paddingBottom: 30,
      display: "flex",
      justifyContent: "center"
    };
    t3 = <input type="hidden" name="companyName" id="companyName" value={AVTALEGIRO_COMPANY_NAME} />;
    t4 = <input type="hidden" name="companyAccountNo" id="companyAccountNo" value={AVTALEGIRO_COMPANY_ACCOUNT_NO} />;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== donation.kid) {
    t5 = <input type="hidden" name="kid" id="kid" value={donation.kid} />;
    $[6] = donation.kid;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = totalSumIncludingTip && totalSumIncludingTip > AVTALEGIRO_MIN_AMOUNT_LIMIT ? totalSumIncludingTip : AVTALEGIRO_MIN_AMOUNT_LIMIT;
  let t7;
  if ($[8] !== t6) {
    t7 = <input type="hidden" name="amountLimit" id="amountLimit" value={t6} />;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = `${API_URL}/avtalegiro/${donation.kid}/redirect`;
  let t9;
  if ($[10] !== t8) {
    t9 = <input type="hidden" name="returnUrl" id="returnUrl" value={t8} />;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <input type="hidden" name="notificationDisabled" id="notificationDisabled" value="false" />;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== onSubmit) {
    t11 = e_0 => onSubmit(e_0);
    $[13] = onSubmit;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== buttonText || $[16] !== t11) {
    t12 = <SubmitButton onClick={t11}>{buttonText}</SubmitButton>;
    $[15] = buttonText;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t12 || $[19] !== t5 || $[20] !== t7 || $[21] !== t9) {
    t13 = <div><form data-cy="avtalegiro-form" id="avtalegiro-form" action={AVTALEGIRO_FORM_URL} method="post" target="_parent" style={t2}>{t3}{t4}{t5}{t7}{t9}{t10}{t12}</form></div>;
    $[18] = t12;
    $[19] = t5;
    $[20] = t7;
    $[21] = t9;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  return t13;
};